import CooperateIcon from 'component/Icon/CooperateIcon';
import React from 'react';
import styles from './Navigator.module.scss';
type SwitchProps = {
  prev: () => void;
  today: () => void;
  next: () => void;
}
const Switch: React.FC<SwitchProps> = ({ prev, today, next }) => {
  return (
    <div className={styles.switchWrapper}>
      <div className={`${styles.arrow} ${styles.left}`} onClick={prev}>
        <CooperateIcon type="iconic_arrow_left" size="12"/>
      </div>
      <div className={`${styles.content}`} onClick={today}>今</div>
      <div className={`${styles.arrow} ${styles.right}`} onClick={next}>
        <CooperateIcon type="iconic_arrow_right" size="12"/>
      </div>
    </div>
  );
};
type IProps = {
  dateFormat: string;
} & SwitchProps
const Navigator: React.FC<IProps> = ({ dateFormat, ...props }) => {
  return (
    <div>
      <div className={styles.navigation}>
        <div className={styles.date}>{dateFormat}</div>
        <Switch { ...props }/>
      </div>
    </div>
  );
};

export default Navigator;
